export default "<footer class=\"footer-section\">\n    <h4 class=\"title \">{{title}}</h4>\n    <p class=\"text m-0\">{{description}}</p>\n</footer>"